import { PriceFeedSeeder } from './price-feed-seeder.cls';
/**
 *
 */
export var NSSeeders = {
    PriceFeedSeeder: PriceFeedSeeder
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/seeder/index.ts
// module id = null
// module chunks = 